import { careersRoutePath } from '@bcf-v2/routes-landings/sportsbook/app/paths/careers-route-path';
import { cmsLandingPageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-landing-page-route-path';
import { cmsSeoLandingPageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-landing-page-seo-route-path';
import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { promotionsRoutePath } from '@bcf-v2/routes-statics/common/app/paths/promotions-route-path';
import { supportRoutePath } from '@bcf-v2/routes-statics/common/app/paths/support-route-path';
import { betOnActionRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/bet-on-action-route-path';
import { bpBetBuilderRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/bp-bet-builder-route-path';
import { esportRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/esport-route-path';
import { liveBettingRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/live-betting-route-path';
import { lotteryRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/lottery-route-path';
import { playerBetsRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/player-bets-paths';
import { preMatchesRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/pre-matches-route-path';
import { resultsCenterRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/results-center-route-path';
import { virtualGameCardsRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/virtual-game-cards-route-path';
import { virtualSportsRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/virtual-sports-route-path';
import { FooterLink } from '../types';

export const footerLinksFn = (currentLang?: string): FooterLink[][] => [
  [
    {
      url: cmsSimplePageRoutePath('about-us'),
      title: $localize`About us`
    },
    {
      url: cmsLandingPageRoutePath('locals'),
      title: $localize`Locals`
    },
    {
      title: $localize`Check bet`,
      modalFragmentLink: 'check-bet'
    },
    {
      url: cmsLandingPageRoutePath('press'),
      title: $localize`Press`
    },
    {
      url: careersRoutePath(),
      title: $localize`Careers`
    },
    {
      url: 'https://lvbet.pl/blog/',
      title: $localize`Blog`
    },
    {
      url: resultsCenterRoutePath(),
      title: $localize`Results`
    },
    {
      url: cmsLandingPageRoutePath('cooperation'),
      title: $localize`Cooperation`
    }
  ],
  [
    {
      url: preMatchesRoutePath(),
      title: $localize`Sports`
    },
    {
      url: liveBettingRoutePath(),
      title: $localize`Live betting`
    },
    {
      url: esportRoutePath(),
      title: $localize`Esport`
    },
    {
      url: promotionsRoutePath(),
      title: $localize`Bonuses`
    },
    {
      url: 'https://sports-stats.lvbet.pl/scoreframe/pl/soccer/events',
      title: $localize`Statistics`
    },
    ...(currentLang === 'pl'
      ? [
          {
            url: cmsSeoLandingPageRoutePath('promo-code'),
            title: $localize`LV BET promo code`
          }
        ]
      : [])
  ],
  [
    {
      url: bpBetBuilderRoutePath(),
      title: $localize`Betbuilder`
    },
    {
      url: playerBetsRoutePath(),
      title: $localize`Player Bets`,
      bottomSheetKind: 'dst-player-bets'
    },
    {
      url: virtualGameCardsRoutePath(),
      title: $localize`Games`
    },
    {
      url: virtualSportsRoutePath(),
      title: $localize`Virtual sports`
    },
    {
      url: betOnActionRoutePath(),
      title: 'LV Jackpot'
    },
    {
      url: lotteryRoutePath(),
      title: $localize`LV Koło`
    },
    {
      url: cmsLandingPageRoutePath('vip-club'),
      title: $localize`Vip Club`
    }
  ],
  [
    {
      url: supportRoutePath(),
      title: $localize`Support`
    },
    {
      url: cmsSimplePageRoutePath('terms-and-conditions'),
      title: $localize`Terms and conditions`
    },
    {
      url: cmsSimplePageRoutePath('responsible-gaming'),
      title: $localize`Responsible gaming`
    },
    {
      url: cmsSimplePageRoutePath('privacy-policy'),
      title: $localize`Privacy Policy`
    },
    {
      url: cmsSimplePageRoutePath('sitemap'),
      title: $localize`Sitemap`
    }
  ],
  [
    {
      url: cmsLandingPageRoutePath('mobile-application'),
      title: $localize`Mobile application`
    },
    {
      url: cmsLandingPageRoutePath('cash-out'),
      title: $localize`Cashout`
    }
  ]
];
